import { Flex, Form, Select, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { lineAmountTypeReferences } from '../../../../../data/qbooks/statics/lineAmountType';
import { messages } from './AccountLineItemsToolbar.messages';
import { AccountLineItemsToolbarProps } from './AccountLineItemsToolbar.types';

export const AccountLineItemsToolbar = memo<AccountLineItemsToolbarProps>((props) => {
    const { withTaxFeature = false } = props;

    return (
        <Form.Part>
            <Flex width='100%' alignItems='center' justifyContent='space-between' spacing='16'>
                <Text font='headline' fontSize='xxsmall' fontWeight='medium' color='midnight80' spacing='20 0'>
                    {messages.headerText}
                </Text>

                {withTaxFeature && (
                    <Flex alignItems='center' spacing='16'>
                        <Text font='label' fontSize='small' fontWeight='regular'>
                            {messages.lineAmountTypeLabel}
                        </Text>

                        <Select
                            name='lineAmountType'
                            items={lineAmountTypeReferences}
                            size='small'
                            itemIdKey='id'
                            itemNameKey='text'
                            clearable={false}
                        />
                    </Flex>
                )}
            </Flex>
        </Form.Part>
    );
});

AccountLineItemsToolbar.displayName = 'AccountLineItemsToolbar';
